import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

/**
 * Combines class names with Tailwind merge support.
 * @param {...(string|undefined|null|false)} inputs - Class names to combine.
 * @returns {string} - Merged class names.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
